import { type SupabaseClient, createClient } from '@supabase/supabase-js'

let _client: SupabaseClient | null = null

/** Lazy singleton — throws on first touch if env is missing (same pattern as apps/app). */
export function getSupabase(): SupabaseClient {
  if (_client) return _client
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined
  if (!url || !key) {
    throw new Error('Missing Supabase env vars: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY')
  }
  _client = createClient(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // PKCE + URL detection: required by the auth trio (F4) — Google OAuth
      // bounces back to /new with ?code=, and password-recovery emails land
      // on /reset-password. Harmless on /join + /room (no auth params there).
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  })
  return _client
}

export async function getAccessToken(): Promise<string | null> {
  const { data } = await getSupabase().auth.getSession()
  return data.session?.access_token ?? null
}
